document.addEventListener('DOMContentLoaded', function () {
    const videoContainers = document.querySelectorAll('.acf-video-container');

    videoContainers.forEach(container => {
        const videoElement = container.querySelector('video');
        const overlay = container.querySelector('.acf-video-overlay');
        const iframe = container.querySelector('iframe');
        let vimeoPlayer = null;

        if (!overlay) return;

        const playVideo = () => {
            overlay.classList.add('clicked');
            const delay = window.innerWidth <= 768 ? 1000 : 500;

            setTimeout(() => {
                container.classList.add('is-playing');

                if (videoElement) {
                    videoElement.play();
                } else if (iframe) {
                    if (typeof Vimeo !== 'undefined') {
                        if (!vimeoPlayer) {
                            vimeoPlayer = new Vimeo.Player(iframe);
                            vimeoPlayer.on('pause', showOverlay);
                            vimeoPlayer.on('ended', showOverlay);
                        }
                        vimeoPlayer.play();
                    }
                }
            }, delay);
        };

        const showOverlay = () => {
            container.classList.remove('is-playing');
            overlay.classList.remove('clicked');

            if (videoElement) {
                videoElement.pause();
            }
        };

        overlay.addEventListener('click', playVideo);
        let touchStartY = 0;

        overlay.addEventListener('touchstart', function (e) {
            touchStartY = e.changedTouches[0].screenY;
        }, { passive: true });

        overlay.addEventListener('touchend', function (e) {
            if (window.innerWidth <= 768) {
                const touchEndY = e.changedTouches[0].screenY;

                if (Math.abs(touchEndY - touchStartY) < 10) {
                    e.preventDefault();
                    playVideo();
                }
            }
        });

        overlay.addEventListener('click', function (e) {
            if (window.innerWidth > 768) {
                playVideo();
            }
        });

        if (videoElement) {
            videoElement.addEventListener('ended', showOverlay);
            videoElement.addEventListener('pause', showOverlay);

            videoElement.addEventListener('click', () => {
                if (!videoElement.paused) {
                    videoElement.pause();
                }
            });
        }
    });
});